import { PlusCircleFilled } from "@ant-design/icons";
import {
  Card,
  Col,
  message,
  Row,
  Select,
  Space,
  Form,
  Input,
  Button,
} from "antd";
import React from "react";
import { TypeIva } from "../../api/utils";
import { useProductStore } from "./LayoutProducto";
import { ContableItems } from "./ContableItems";

export const productStore = 1;
const { Option } = Select;

export const ProductSimple = ({ addProductSimple }) => {
  const producto = useProductStore();

  const onFinish = (values) => {
    console.log("::values", values);
    producto.setData({ productstore: productStore });
    addProductSimple(productStore);
  };

  const onFinishFailed = (errorInfo) => {
    message.info("Por favor complete todos los campos");
  };

  return (
    <Row justify="center" style={{ marginTop: "5px" }}>
      <Space direction="horizontal">
        <Col span={24} className="site-card-border-less-wrapper">
          <Card
            hoverable
            bordered
            title="Detalles del producto"
            style={{
              borderRadius: "12px",
              margin: 5,
            }}
          >
            <Form
              name="basic"
              layout="vertical" // Labels arriba de los campos
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              initialValues={{
                Codigo: producto.data.Codigo,
                IdCategoria: producto.data.IdCategoria,
                IdSubCategoria: producto.data.IdSubCategoria,
                IdMarca: producto.data.IdMarca,
                Descripcion: producto.data.Descripcion,
                PrecioVentaConIva1: producto.data.PrecioVentaConIva1,
                PorcentajeIva: producto.data.PorcentajeIva,
                cat0: producto.data.ParametrizacionContableProducto?.[0]
                  ?.NumeroCuenta,
                cat1: producto.data.ParametrizacionContableProducto?.[1]
                  ?.NumeroCuenta,
                cat2: producto.data.ParametrizacionContableProducto?.[2]
                  ?.NumeroCuenta,
                cat3: producto.data.ParametrizacionContableProducto?.[3]
                  ?.NumeroCuenta,
                cat4: producto.data.ParametrizacionContableProducto?.[4]
                  ?.NumeroCuenta,
                weight: producto.data.weight,
              }}
            >
              <div style={{ marginBottom: "32px" }}>
                <h3
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    marginBottom: "16px",
                    color: "#555",
                  }}
                >
                  Información Básica
                </h3>
                <Row
                  gutter={[24, 16]}
                  style={{
                    marginLeft: "-12px",
                    marginRight: "-12px",
                    rowGap: "0px",
                  }}
                >
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="Código de Referencia"
                      name="Codigo"
                      rules={[
                        {
                          required: false,
                          message: "Digita la referencia del producto",
                        },
                      ]}
                      tooltip="Código único para identificar el producto (opcional)"
                    >
                      <Input
                        placeholder="Digita el código de referencia del producto"
                        maxLength={45}
                        onChange={(value) =>
                          producto.setData({ Codigo: value.target.value })
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="Nombre del Producto"
                      name="Descripcion"
                      rules={[
                        {
                          required: true,
                          message: "Digite el nombre del producto",
                        },
                      ]}
                      tooltip="Nombre descriptivo del producto"
                    >
                      <Input
                        placeholder="Ej: Camiseta de Algodón"
                        onChange={(value) =>
                          producto.setData({ Descripcion: value.target.value })
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      name="IdCategoria"
                      label="Categoría"
                      rules={[
                        { required: true, message: "Selecciona una categoría" },
                      ]}
                      tooltip="Selecciona la categoría principal del producto"
                    >
                      <Select
                        onChange={(value) =>
                          producto.setData({
                            IdCategoria: value,
                            Categoria: producto.knowName(
                              value,
                              producto.categorys
                            ),
                          })
                        }
                        placeholder="Selecciona una categoría"
                        allowClear
                        showSearch
                        style={{ width: "100%" }}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                      >
                        {producto.categorys.map((category) => (
                          <Option key={category.id} value={category.id}>
                            {category.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      name="IdSubCategoria"
                      label="Subcategoría"
                      rules={[
                        {
                          required: false,
                          message: "Selecciona una subcategoría",
                        },
                      ]}
                      tooltip="Selecciona una subcategoría (opcional)"
                    >
                      <Select
                        onChange={(value) =>
                          producto.setData({
                            IdSubCategoria: value,
                            SubCategoria: producto.knowName(
                              value,
                              producto.categorys
                            ),
                          })
                        }
                        placeholder="Selecciona una subcategoría"
                        allowClear
                        showSearch
                        style={{ width: "100%" }}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                      >
                        {producto.categorys.map((category) => (
                          <Option key={category.id} value={category.id}>
                            {category.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={12}>
                  <Form.Item
                  name="IdMarca"
                  label="Marca"
                  tooltip="Selecciona una marca (opcional)"
                >
                  <Select
                    onChange={(value) => {
                      const selectedBrand = producto.brands.find((b) => b.id === value);
                      producto.setData({
                        IdMarca: value,
                        Marca: selectedBrand?.name,
                        tags: selectedBrand?.name ? [selectedBrand.name] : [],
                      });
                    }}
                    placeholder="Selecciona una marca"
                    allowClear
                    showSearch
                    style={{ width: "100%" }}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                  >
                    {producto.brands.map((brand) => (
                      <Option key={brand.id} value={brand.id}>
                        {brand.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                  </Col>
                </Row>
              </div>

              <div style={{ marginBottom: "32px" }}>
                <h3
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    marginBottom: "16px",
                    color: "#555",
                  }}
                >
                  Detalles Contables
                </h3>
                <p>
                  Al crear un producto, debes asignarle su parametrización
                  contable para un correcto registro financiero y control de
                  inventario.
                </p>
                <br />
                <ContableItems />
              </div>

              <div style={{ marginBottom: "32px" }}>
                <h3
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    marginBottom: "16px",
                    color: "#555",
                  }}
                >
                  Precio de venta
                </h3>
                <Row
                  gutter={[24, 16]}
                  style={{
                    marginLeft: "-12px",
                    marginRight: "-12px",
                    rowGap: "0px",
                  }}
                >
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="Precio de Venta"
                      name="PrecioVentaConIva1"
                      rules={[
                        {
                          required: true,
                          message: "Digite el precio de venta",
                        },
                      ]}
                      tooltip="Precio de venta al público (incluye IVA)"
                    >
                      <Input
                        placeholder="$200.000"
                        type="number"
                        onChange={(value) =>
                          producto.setData({
                            PrecioVentaConIva1: parseInt(value.target.value),
                            PrecioVentaConIva2: parseInt(value.target.value),
                            PrecioVentaConIva3: parseInt(value.target.value),
                          })
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              <div style={{ marginBottom: "32px" }}>
                <h3
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    marginBottom: "16px",
                    color: "#555",
                  }}
                >
                  Dimensiones
                </h3>
                <Row
                  gutter={[24, 16]}
                  style={{
                    marginLeft: "-12px",
                    marginRight: "-12px",
                    rowGap: "0px",
                  }}
                >
                  <Col xs={24} lg={8}>
                  <Form.Item
                      label="Peso del Producto"
                      name="weight"
                      rules={[
                        {
                          required: true,
                          message: "Digite el peso del producto",
                        },
                      ]}
                      tooltip="Peso del producto (ej: 1 kg, 0.3 kg)"
                    >
                      <Input
                        placeholder="(1): kg | (0.3)"
                        type="text"
                        onChange={(value) =>
                          producto.setData({ weight: value.target.value })
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={8}>
                  <Form.Item
                    label="Largo (cm)"
                    name="length"
                    rules={[{ required: true, message: "Digita el largo" }]}
                  >
                    <Input
                      type="number"
                      placeholder="Ej: 10"
                      onChange={(e) =>
                        producto.setData({
                          dimensions: {
                            ...producto.data.dimensions,
                            length: e.target.value,
                          },
                        })
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={8}>
                <Form.Item
                  label="Ancho (cm)"
                  name="width"
                  rules={[{ required: true, message: "Digita el ancho" }]}
                >
                  <Input
                    type="number"
                    placeholder="Ej: 5"
                    onChange={(e) =>
                      producto.setData({
                        dimensions: {
                          ...producto.data.dimensions,
                          width: e.target.value,
                        },
                      })
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} lg={8}>
              <Form.Item
                label="Alto (cm)"
                name="height"
                rules={[{ required: true, message: "Digita el alto" }]}
              >
                <Input
                  type="number"
                  placeholder="Ej: 2"
                  onChange={(e) =>
                    producto.setData({
                      dimensions: {
                        ...producto.data.dimensions,
                        height: e.target.value,
                      },
                    })
                  }
                />
              </Form.Item>
            </Col>
                </Row>
              </div>
              <div style={{ marginBottom: "32px" }}>
                <h3
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    marginBottom: "16px",
                    color: "#555",
                  }}
                >
                  Impuestos
                </h3>
                <Row
                  gutter={[24, 16]}
                  style={{
                    marginLeft: "-12px",
                    marginRight: "-12px",
                    rowGap: "0px",
                  }}
                  justify="start"
                >
                  <Col xs={24} lg={8}>
                    <Form.Item
                      name="PorcentajeIva"
                      label="Porcentaje IVA"
                      rules={[
                        {
                          required: true,
                          message: "Selecciona un porcentaje IVA",
                        },
                      ]}
                      tooltip="Selecciona el porcentaje de IVA aplicable"
                    >
                      <Select
                        onChange={(value) =>
                          producto.setData({ PorcentajeIva: value })
                        }
                        placeholder="Selecciona un porcentaje IVA"
                        allowClear
                        style={{ width: "100%" }}
                      >
                        {TypeIva.map((typeiva) => (
                          <Option key={typeiva.Codigo} value={typeiva.Valor}>
                            {typeiva.Descripcion}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              <Form.Item style={{ textAlign: "center", marginTop: "24px" }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  shape="round"
                  size="large"
                  icon={<PlusCircleFilled />}
                  style={{
                    padding: "0 32px",
                    height: "48px",
                    fontSize: "16px",
                    fontWeight: 500,
                    borderRadius: "10px",
                    transition: "all 0.3s ease",
                  }}
                >
                  Crear Producto
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Space>
    </Row>
  );
};
